export default __webpack_public_path__ + "static/media/Offer.a62fb6cb.jpg";